<template>
	<drawer
			:title="getNameDrawer"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0 0 10px 0"
				:class-error="getError('contactType')"
				@updateSelect="onSelect($event, 'contactType')"
				:autocompleteValue="contactType"
				:items="contactsTypes"
				label="Type"
				is-select
				:isClearable="false"
				is-attach
				is-required
				item-text="name"
				item-value="id"
		></field>
		<field
				v-if="getExtensionTypeList"
				margin="0 0 10px 0"
				:class-error="getError('extensionType')"
				@updateSelect="onSelect($event, 'extensionType')"
				:autocompleteValue="extensionType"
				:items="extensionTypeList"
				label="Extension type"
				is-select
				:isClearable="false"
				is-attach
				is-required
				item-text="name"
				item-value="id"
		></field>
		<field
				:class-error="getError('value')"
				margin="0 0 10px 0"
				width="300px"
				label="Value"
				placeholder="Enter value"
				:setInputValue="value"
				@updateInput="onInput($event, 'value')"
				is-required
		></field>
		
	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "EditContact",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		item: {
			type: Object,
			default: function() {
				return null; 
			}
		},
		contactsTypes: Array
	},

	computed: {
		getNameDrawer() {
			if (this.item) return 'Edit this contact';
			return 'Add new contact';
		},
		getExtensionTypeList() {
			return !!this.extensionTypeList && this.extensionTypeList.length > 0;
		},
	},
	validations: {
		contactType: { required },
		value: { required },
	},

	data() {
		return {

			contactType: null,
			extensionType: null,
			extensionTypeList: null,

			uniqKey: null,
			id: null,
			value: null,
			icon: null,
			name: null,
			extension: null,
			contact_type_id: null,
			extension_id: null
		};
	},
	methods: {

		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { id, value, icon, name, extension, contact_type_id, extension_id, uniqKey } = this.$data;
				this.$emit('updateSave', { id, value, icon, name, extension, contact_type_id, extension_id, uniqKey });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},

		onSelect(payload, key) {
			// payload може бути: { value: obj } або { value: id } або null/undefined
			const selected = payload && payload.value !== undefined ? payload.value : null;

			if (!selected) return; //  якщо нічого не вибрано — просто вихід

			// Якщо прилетів id (number), знайдемо об’єкт у списках
			let obj = selected;

			if (typeof selected !== 'object') {
				if (key === 'contactType') {
					obj = (this.contactsTypes || []).find(function(it) {
						return it.id === selected; 
					});
				}
				if (key === 'extensionType') {
					obj = (this.extensionTypeList || []).find(function(it) {
						return it.id === selected; 
					});
				}
			}

			if (!obj) return; //  якщо не знайшли — вихід

			// тепер obj точно об’єкт
			const type = obj.type;
			const icon = obj.icon;
			const id = obj.id;
			const name = obj.name;

			this[key] = obj;

			if (key === 'contactType') {
				this.extensionTypeList = (type && type.length > 0) ? type : null;

				this.icon = icon;
				this.contact_type_id = id;
				this.name = name;

				// скидаємо extension
				this.extension = null;
				this.extension_id = null;
				this.extensionType = null;
			}

			if (key === 'extensionType') {
				this.extension = name;
				this.extension_id = id;
			}
		},

		onInput({ value }, key) {
			this[key] = value;
		},
	},
	mounted() {
		if (this.item) {
			const {
				id,
				value,
				icon,
				name,
				extension,
				contact_type_id,
				extension_id,
				uniqKey,

			} = this.item;

			const idExt = contact_type_id;
			const ext = (this.contactsTypes || []).find(function(it) {
				return it.id === idExt; 
			});
			this.extensionTypeList = (ext && ext.type && ext.type.length) ? ext.type : null;

			this.uniqKey = uniqKey;
			this.id = id;
			this.value = value;
			this.icon = icon;
			this.name = name;
			this.extension = extension;
			this.contact_type_id = contact_type_id;
			this.extension_id = extension_id;
			this.contactType = (this.contactsTypes || []).find(function(it) {
				return it.id === contact_type_id; 
			}) || null;
			this.extensionType = (this.extensionTypeList || []).find(function(it) {
				return it.id === extension_id; 
			}) || null;

		}
	}
};

</script>
